import React from 'react';

const SvgMagnifyingGlass = (props) => (
  <svg width={16} height={16} {...props}>
    <path
      fill="currentColor"
      d="M5.982 0c3.297 0 5.982 2.792 5.982 6.221 0 1.49-.503 2.856-1.346 3.927l4.767 4.958-.86.894-4.767-4.957a5.797 5.797 0 0 1-3.776 1.4C2.685 12.442 0 9.65 0 6.22 0 2.792 2.685 0 5.982 0zm0 1.244c-2.65 0-4.786 2.221-4.786 4.977 0 2.756 2.136 4.977 4.786 4.977 2.65 0 4.785-2.221 4.785-4.977 0-2.756-2.135-4.977-4.785-4.977z"
    />
  </svg>
);

export default SvgMagnifyingGlass;
